import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/modeling-service.svg
 */
const IconModelingService: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M23.153.484H.87a.364.364 0 00-.262.109A.37.37 0 00.5.857v16.34a.372.372 0 00.37.37h9.652v2.972H7.915a2.605 2.605 0 00-2.606 2.607.37.37 0 00.37.37h12.632a.374.374 0 00.376-.37 2.607 2.607 0 00-2.606-2.607h-2.608v-2.972h9.655a.372.372 0 00.345-.229.37.37 0 00.027-.142V.856a.373.373 0 00-.347-.372zm-5.236 22.284H6.11a1.86 1.86 0 011.82-1.485h8.17a1.853 1.853 0 011.81 1.482l.007.003zm-5.16-2.23h-1.485v-2.97h1.486v2.97zm10.026-3.713H1.243V1.227h21.54v15.598z"
      fill="currentColor"
    />
    <path
      d="M22.033 15.336h-.742v.742h.742v-.742zM20.549 15.336h-1.486v.742h1.486v-.742zM2.35 14.594h19.311a.371.371 0 00.374-.373V2.337a.372.372 0 00-.374-.371H2.351a.371.371 0 00-.37.37v11.885a.372.372 0 00.37.373zM2.724 2.71h18.57v11.14H2.723V2.71z"
      fill="currentColor"
    />
    <path
      d="M16.608 6.08l-4.461-1.857a.369.369 0 00-.286 0L7.406 6.08a.371.371 0 00-.229.343v3.713a.371.371 0 00.23.343l4.454 1.857a.362.362 0 00.284 0l4.46-1.857a.375.375 0 00.228-.343V6.423a.376.376 0 00-.225-.343zm-4.6-1.113l3.491 1.456-3.491 1.453-3.491-1.453 3.49-1.456zm4.085 3.064l-.743.31V7.29l.743-.309v1.05zM7.92 6.98l.744.308v1.053l-.744-.31V6.98zm1.487.617l.742.31v1.053l-.742-.31V7.597zm2.968.93l.742-.31V9.27l-.742.309V8.528zm-.744 1.05l-.742-.308V8.217l.742.309v1.053zm-1.482.187v1.053l-.742-.31V9.453l.742.311zm.74.309l.742.309v1.053l-.742-.31v-1.052zm1.486.31l.742-.31v1.053l-.742.309v-1.051zm1.486-.619l.742-.309v1.051l-.742.311V9.765zm0-.802v-1.05l.742-.311v1.052l-.742.31zM7.92 8.841l.744.309v1.052l-.744-.308V8.84zm7.43 1.361V9.15l.742-.31v1.054l-.743.308zM4.579 3.451a1.11 1.11 0 00-1.089 1.33 1.111 1.111 0 101.876-1.003 1.112 1.112 0 00-.787-.327zm0 1.486a.37.37 0 01-.343-.229.371.371 0 11.343.229zM4.579 6.423a1.11 1.11 0 00-1.089 1.33A1.111 1.111 0 105.366 6.75a1.11 1.11 0 00-.787-.327zm0 1.486a.37.37 0 01-.343-.23.37.37 0 11.713-.141.37.37 0 01-.37.365v.006zM4.579 9.394a1.112 1.112 0 00-1.093 1.333A1.115 1.115 0 104.58 9.395zm0 1.486a.373.373 0 11-.004-.745.373.373 0 01.004.745zM19.435 7.903a1.117 1.117 0 00-1.028.688 1.113 1.113 0 101.028-.688zm0 1.486a.37.37 0 01-.364-.443.37.37 0 01.671-.136.37.37 0 01.063.206.372.372 0 01-.37.379v-.006zM19.435 10.88a1.116 1.116 0 00-1.09 1.331 1.114 1.114 0 101.877-1.005 1.117 1.117 0 00-.787-.326zm0 1.484a.368.368 0 01-.343-.23.372.372 0 01.27-.505.368.368 0 01.38.158.37.37 0 01-.307.577z"
      fill="currentColor"
    />
  </svg>
);

export default IconModelingService;
